// src/components/remediationScorecardDrillThrough.js
// The link from a Remediation Scorecard category row to the Risks page, and its parsing there.

// Sent in place of an empty original category, which the row shows as "Uncategorized".
const BLANK_CATEGORY = "__blank__";

/** The /risks URL for one category row. Each original is its own `category` param, so commas survive. */
export const buildDrillThroughUrl = (source, row) => {
    const params = new URLSearchParams();
    if (source.controlSourceFilter != null) {
        // No `types`: one source key can hold GRC and External risks, and riskListType names only one.
        params.append("controlSource", source.controlSourceFilter);
        // Mixed origin: the key also holds blank-source risks of this type, which the control source alone would drop.
        if (source.blankControlSourceRiskType != null) params.append("blankRiskType", source.blankControlSourceRiskType);
    } else {
        params.append("types", source.riskListType);
    }
    (row.originalCategories || []).forEach((original) => {
        params.append("category", (original ?? "").trim() === "" ? BLANK_CATEGORY : original);
    });
    if (row.isMapped) params.append("scorecardCategory", row.category);
    if (source.underlyingRiskType != null) params.append("riskType", source.underlyingRiskType);
    if (source.blankControlSourceOnly) params.append("blankControlSource", "1");
    return `/risks?${params.toString()}`;
};

/** The URL's categories, trimmed and lower-cased, with blank as an empty string; null when there are none. */
export const parseCategories = (searchParams) => {
    const values = searchParams.getAll("category");
    if (values.length === 0) return null;
    return new Set(values.map((value) => {
        const trimmed = value.trim();
        return trimmed === BLANK_CATEGORY ? "" : trimmed.toLowerCase();
    }));
};
